export default "__VITE_ASSET__BXBN8YJX__"